import AxiosInstance from "../config/AxiosInstance";

export interface ServiceChargePayload {
  chargeType: string | number;
  enabled: boolean;
  optional: boolean;
  taxable: boolean;
  percentageValue?: number | null;
  fixedAmount?: number | null;
}

export const createServiceCharge = async (payload: ServiceChargePayload) => {
  try {
    const { data } = await AxiosInstance.post("/api/service-charge-settings/create", payload);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getServiceChargeList = async (
  page: number = 1,
  limit: number = 10,
  searchValue: string = ""
) => {
  try {
    const { data } = await AxiosInstance.get("/api/service-charge-settings/get", {
      params: { page, limit, searchValue },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getServiceChargeById = async (id: string) => {
  try {
    const { data } = await AxiosInstance.get(`/api/service-charge-settings/get-one/${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateServiceCharge = async (id: string, payload: ServiceChargePayload) => {
  try {
    const { data } = await AxiosInstance.put(`/api/service-charge-settings/update/${id}`, payload);
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteServiceCharge = async (id: string) => {
  try {
    const { data } = await AxiosInstance.delete(`/api/service-charge-settings/delete/${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};
